import Handle from '__pages/AutomationEngine/Engine/Handle';
import { Wrapper, Body, RelativeKizenTypo } from './common';
import { Placeholder as StyledPlaceHolder } from 'pages/AutomationEngine/Draggable';
import { Position } from 'reactflow';

export type PlaceholderProps = {
  placeholderText: string;
  props: any;
};

export const Placeholder = ({
  placeholderText,
  ...props
}: PlaceholderProps) => {
  return (
    <StyledPlaceHolder {...props} dragging={false}>
      <Wrapper>
        <Body>
          <RelativeKizenTypo as="span">{placeholderText}</RelativeKizenTypo>
        </Body>
        <Handle
          id="handle-left"
          type="target"
          position={Position.Left}
          style={{
            left: 0,
            top: '50%',
          }}
        />
        <Handle
          id="handle-right"
          type="source"
          position={Position.Right}
          style={{
            right: 0,
            top: '50%',
          }}
        />
        {/* The same top/bottom handles as StepCard, so edges that attach
            there - e.g. a loop span arriving at its Next/Finish - stay
            connected while the card is shown as a placeholder. */}
        <Handle
          id="handle-top"
          type="target"
          position={Position.Top}
          style={{ top: 0 }}
        />
        <Handle
          id="handle-bottom"
          type="source"
          position={Position.Bottom}
          style={{ bottom: 0 }}
        />
        <Handle
          id="handle-bottom-target"
          type="target"
          position={Position.Bottom}
          style={{ bottom: 0 }}
        />
      </Wrapper>
    </StyledPlaceHolder>
  );
};
